export class PractitionerDayOff {
    id: number;
    active: boolean;
    practitionerId: number;
    healthSystemId: number;
    reason: string;
    startDate: Date;
    endDate: Date;
    startDateStartTime: Date;
    startDateEndTime: Date;
    endDateStartTime: Date;
    endDateEndTime: Date;
    startTime: string;
    endTime: string;
    strStartTime: string;
    strEndTime: string;
    isFullDay: boolean;
}

